<template>
  <div class="app-container" :style="{ width:   (1 <= +activeName && +activeName <= 2) || (7 <= +activeName && +activeName <= 8) ? '2715px' : '1710px' }">
    <div v-loading="loading">
      <el-tabs tab-position="left" v-model="activeName" @tab-click="handleClick">
        <template v-for="(item, i) in fireTipData">
          <el-tab-pane
            :key="i"
            :label="item.title"
            :name="i + ''"
          >
            <three v-if="deviceList.length > 0" :device-list="deviceList" :text-list="item.textList" />
          </el-tab-pane>
        </template>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { selectElectricity } from '@/api/business/base/tenant/map'

import Three from './component/three'
export default {
  components: {
    Three
  },
  data() {
    return {
      activeName: '0',
      deviceAllList: [],
      deviceList: [],
      loading: false,
      fireTipData: [
        {
          title: '西府2号楼楼顶电梯机房',
          deviceIds: [28464, 28470],
          textList: ['100/5', '75/5', '100/5', '100/5', '200/5', '400/5', '400/5'],
        },
        {
          title: '西府B2车库配电室',
          deviceIds: [28471, 28485],
          textList: ['100/5', '100/5', '100/5'],
        },
        {
          title: '西府1号楼B1层配电室',
          deviceIds: [28486, 28502],
          textList: ['50/5', '100/5', '300/5', '400/5', '100/5'],

        },
        {
          title: '西府2号楼1单元B1层竖井',
          deviceIds: [28503],
          textList: ['150/5', '150/5', '400/5', '400/5', '50/5', '400/5', '400/5'],
        },
        {
          title: '西府2号楼2单元B1层竖井',
          deviceIds: [28504],
          textList: ['100/5', '300/5', '100/5', '100/5', '100/5', '100/5'],
        },
        {
          title: '西府2号楼2单元B1层竖井',
          deviceIds: [28505],
          textList: ['250/5', '250/5', '200/5', '50/5'],
        },
        
        {
          title: '西府2号楼B1层配电室',
          deviceIds: [28506, 28519],
          textList: ['50/5', '50/5', '50/5', '100/5', '100/5', '50/5', '100/5'],
        },
        {
          title: '西府会所',
          deviceIds: [28632, 28650],
          textList: ['250/5', '250/5'],
        }

      ]
    };
  },
  created() {
    if (this.$route.query.index) {
      this.activeName = this.$route.query.index
    }
    this.loading = true
    selectElectricity({ categoryId: 16, positionParentId: 35 }).then(res => {
      this.deviceAllList = res
    }).then(() => {
      const minId = this.fireTipData[+this.activeName].deviceIds[0]
      const maxId = this.fireTipData[+this.activeName].deviceIds[this.fireTipData[+this.activeName].deviceIds.length - 1]
      const obj = this.deviceAllList.filter(k => k.deviceId >= minId && k.deviceId <= maxId)
      this.deviceList = obj.sort(this.sortNumber)
    }).then(() => {
      this.loading = false
    }).catch(() => {
      this.loading = false
    })

  },
  methods: {
    // 排序
    sortNumber(a, b) {
      return +a.deviceId - +b.deviceId
    },
    handleClick() {
      this.deviceList = []
      const minId = this.fireTipData[+this.activeName].deviceIds[0]
      const maxId = this.fireTipData[+this.activeName].deviceIds[this.fireTipData[+this.activeName].deviceIds.length - 1]
      const obj = this.deviceAllList.filter(k => k.deviceId >= minId && k.deviceId <= maxId)
      this.deviceList = obj.sort(this.sortNumber)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  width: 1710px;
}
.el-tabs {
  background-color: #ffffff;
}
</style>